module.exports = __webpack_public_path__ + "static/media/shareBtn.459f638f.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/images/shareBtn.png
// module id = 979
// module chunks = 0